import { cva } from "class-variance-authority";

const stylesBg = cva(
  "invisible absolute top-[64px] group-hover:visible w-[336px] right-0 flex flex-col shadow-lg rounded-[8px] overflow-hidden",
  {
    variants: {
      mode: {
        light: "bg-light-background",
        dark: "bg-dark-background"
      }
    }
  }
);

export { stylesBg };
